<template>
  <div class="create-pro-box">
    <header-back
      :title="type === 'inquery' ?'创建询盘管理项目': '创建会员管理项目'"
      @back="resetHandler"
    />
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <div class="pro-name-count">
        <cube-form-item :field="fields[0]" />
        <em>{{ model.projectname ? (20-model.projectname.length) : 20 }}</em>
      </div>
      <cube-form-item :field="fields[1]">
        <div class="select-list">
          <div
            class="create-pro-item"
            @click="selectAdmin"
          >
            <span
              v-if="adminid.length>0"
              class="admin-name-box"
            >
              {{ adminName.join(',') }}
            </span>
            <span
              v-else
              class="add-admin-tip"
            >请选择负责人</span>
            <i class="cubeic-arrow" />
          </div>
          <select-list
            :visible="visible"
            @close="getadminList"
          />
        </div>
      </cube-form-item>
      <div
        v-if="type === 'member'"
        class="related-pro-container"
      >
        <cube-form-item class="related-pro-tip">
          <h3>关联询盘管理项目</h3>
          <p>关联后系统将根据询盘数据自动生成会员数据至该会员管理项目。</p>
        </cube-form-item>
        <cube-form-item
          :field="fields[2]"
        >
          <cube-radio-group
            v-model="model.isrelated"
            :options="relatedOptions"
            :horizontal="true"
            position="left"
          />
        </cube-form-item>
        <template v-if="isrelated === 1">
          <cube-form-item :field="fields[3]">
            <div class="select-list">
              <div
                class="create-pro-item"
                @click="getRelatePro"
              >
                <span
                  v-if="relatedProName"
                  class="admin-name-box"
                >
                  {{ relatedProName.join() }}
                </span>
                <span
                  v-else
                  class="add-admin-tip"
                >请选择关联项目</span>
                <i class="cubeic-arrow" />
              </div>
            </div>
          </cube-form-item>
        </template>
      </div>

      <div class="form-btn-box">
        <cube-button
          :light="true"
          type="reset"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import SelectList from './SelectList'
import HeaderBack from '@/components/mobile/HeaderBack'
export default {
  components: {
    SelectList,
    HeaderBack
  },
  data () {
    return {
      validity: {},
      adminid: [],
      adminName: [],
      valid: undefined,
      isrelated: 1,
      relatedProName: '',
      model: {
        projectname: this.$route.query.projectname,
        adminid: this.adminid,
        isrelated: this.isrelated,
        pid: ''
      },
      visible: false,
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'projectname',
          label: this.$t('message["1325"]'),
          props: {
            placeholder: this.$t('message["814"]'),
            maxlength: 20

          },
          rules: {
            required: true
          }
        },
        {
          type: '',
          modelKey: 'adminid',
          label: '负责人',
          props: {
            placeholder: this.$t('message["814"]'),
            maxlength: 20

          },
          rules: {
            required: true
          }
        },
        {
          type: '',
          modelKey: 'isrelated',
          label: '关联项目',
          props: {
            placeholder: this.$t('message["814"]'),
            maxlength: 20

          },
          rules: {
            required: true
          }
        },
        {
          type: '',
          modelKey: 'pid',
          label: '    ',
          props: {
            placeholder: this.$t('message["814"]'),
            maxlength: 20

          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('organization/org', ['datas']),
    relatedOptions () {
      const arr = [
        {
          label: '是',
          value: 1
        },
        {
          label: '否',
          value: 0
        }
      ]
      return arr
    },
    relateProList () {
      const { datas = {} } = this
      let arr = []
      arr = datas[1].map(item => {
        return {
          text: item.projectname,
          value: item.projectid
        }
      })
      return arr
    },
    type () {
      const { type = 'inquery' } = this.$route.query
      return type
    }
  },
  watch: {
    model: {
      handler (val) {
        this.isrelated = val.isrelated
      },
      deep: true
    }
  },
  async mounted () {
    const chain = await this.getAdminId()
    chain.params({ cid: this.$route.query.cid })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['ajaxCreateProject', 'getAdminId', 'fetchProjectList']),
    async submitHandler (e) {
      let obj = {}
      // let _this = this
      const chain = await this.ajaxCreateProject({ cid: this.$route.query.cid })
      obj = Object.assign(this.model, { cid: this.$route.query.cid, adminid: this.adminid, pType: this.type === 'member' ? 2 : 1 })
      chain.params(obj)
        .onSuccess(async (raw) => {
          /* const res1 = await _this.fetchProjectList({ cid: this.$route.query.cid })
          res1.fetch() */

          this.$router.push({
            name: 'ProjectIndexPc',
            query: {
              page: 2,
              cid: this.$route.query.cid,
              type: this.type
            } })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.model.isrelated = this.isrelated
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 2,
          cid: this.$route.query.cid,
          type: this.type
        } })
    },
    getadminList (b, data) {
      const arrId = data.map(item => item.userid)
      this.visible = b
      this.model.adminid = arrId
      this.adminid = arrId
      this.adminName = data.map(item => item.name)
    },
    selectAdmin () {
      this.visible = true
    },
    getRelatePro () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '关联项目',
          data: [this.relateProList],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      this.model.pid = selectedVal.join('')
      this.relatedProName = selectedText
    },
    cancelHandle () {
      this.model.pid = ''
      this.relatedProName = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.create-pro-box::v-deep {
  padding-bottom: 90px;
  font-size: 16px !important;
  .cube-form_standard .cube-form-field{
    font-size: 16px;
  }
  .pro-name-count {
    position: relative;
    em {
      position: absolute;
      font-style: normal;
      right: 10px;
      top: 14px;
      color: #999;
    }
  }

  .cube-form-item {
      min-height: 56px;
      line-height: 56px;
      .cube-form-label {
        color: #888;
      }
    }
    .create-pro-item {
      position: relative;
      .admin-name-box {
        width: 240px;
        display: inline-block;
        line-height: 48px;
        height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        font-size: 16px;
      }
      .cubeic-arrow{
          position:absolute;
          right: 0;
          color: #ccc;
        }
      .add-admin-tip {
        color: #b3b3b3;
        font-size: 16px;
      }
    }
    .related-pro-container {
      .cube-form-item:nth-child(2) {
        border: none !important;
        .border-right-1px:after{
          border: none;
        }
        .cube-validator_valid {
          flex-wrap: wrap;
          .cube-radio-wrap {
            justify-content: flex-start !important;
          }
          .cube-radio:nth-child(2) {
            margin-left: -100px;
          }
        }
      }
    }
    .related-pro-tip{
      padding-top: 16px;
      padding-bottom: 16px;
      h3 {
        font-weight: bold;
        line-height: 21px;
        padding-bottom: 8px;
        font-size: 14px;
      }
      p{
        font-size: 14px;
        color: #999;
        line-height: 21px;
      }
    }
}
</style>
